
document.addEventListener("DOMContentLoaded", function () {

  const params = new URLSearchParams(window.location.search);
  const serviceParam = params.get("service");

  if (serviceParam === "winter-storage") {

    const waitForForm = setInterval(() => {
      const serviceSelect = document.querySelector(
        'select'
      );

      if (serviceSelect) {
        for (let option of serviceSelect.options) {
          if (option.text.trim() === "Winter Storage") {
            serviceSelect.value = option.value;
            serviceSelect.dispatchEvent(new Event("change", { bubbles: true }));
            clearInterval(waitForForm);
            break;
          }
        }
      }
    }, 300);
  }
});
